import { render } from "./VCustomIcon.vue?vue&type=template&id=30f0a29b"
import script from "./VCustomIcon.vue?vue&type=script&lang=js"
export * from "./VCustomIcon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/metiznew/www/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__